import { SUPER_ADMIN_SET_LICENSE_VIEW_MODE } from '../types';
import type { LicenseViewMode } from '../actions';

// Keyed by SuperAdmin tool name (TOOL_BUTTON_NAMES.INSTITUTION_LICENSE / .INDIVIDUAL_LICENSE):
// each license page's search-vs-legacy view mode is tracked independently. Missing keys default
// to 'search' at the selector layer (selectInstitutionalLicenseViewMode and
// selectIndividualLicenseViewMode in selectors/super-admin), not here, so this reducer doesn't
// need to know the set of valid tool names up front.
type LicenseViewModeState = Record<string, LicenseViewMode>;

interface LicenseViewModeAction {
  type: string;
  tool?: string;
  mode?: LicenseViewMode;
}

const initialState: LicenseViewModeState = {};

const LicenseViewModeReducer = (
  state: LicenseViewModeState = initialState,
  action: LicenseViewModeAction,
): LicenseViewModeState => {
  switch (action.type) {
    case SUPER_ADMIN_SET_LICENSE_VIEW_MODE:
      if (!action.tool || !action.mode) return state;
      return { ...state, [action.tool]: action.mode };
    default:
      return state;
  }
};

export default LicenseViewModeReducer;
